export default __webpack_public_path__ + "static/media/CHU6721_tn.428e08cf.jpg";